import React from 'react'
import './testimonial.scss'

function Testimonial() {
    return (
        <div className='testimonial container'>
            {/* SubTitle */}
            <div className="sub-title">
                <div className="title">
                    <h3>TESTIMONIAL.</h3>
                    <div className="shadow"></div>
                </div>
            </div>
            {/* Content */}
            <div className="content">

            </div>
        </div>
    )
}

export default Testimonial